// Live set of lowercase keys currently held. Consumers just check membership.
export const keys = new Set();

// UI systems (dialogs, menus) can block game input while they're open. The
// keyboard listeners for UI sit outside this set and still fire.
let blocked = false;

export function blockGameInput(value) {
  blocked = value;
  if (value) keys.clear();   // drop any keys held at block time
}

export function isGameInputBlocked() { return blocked; }

addEventListener('keydown', (e) => {
  if (blocked) return;
  keys.add(e.key.toLowerCase());
  if (e.key === ' ' || e.key.startsWith('Arrow')) e.preventDefault();
});

addEventListener('keyup', (e) => {
  keys.delete(e.key.toLowerCase());
});
